// encode local storage Data (to-do: sensitive data should be encrypted)

export const encodeData = (data) => {
  return btoa(data); // Convert to Base64 encoded string
};

export const decodeData = (encodedData) => {
  return atob(encodedData); // Decode Base64 encoded string
};
